import React, {useEffect, useState} from "react";
import {
  Box,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
} from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment-timezone';
import { NfdrHourly } from "./nfdrTables/NfdrHourly";
import { NfdrDaily } from "./nfdrTables/NfdrDaily";
import { useLocation } from "react-router-dom";

type FireDangerProps = {
    station: any,
    viewMode: any,
    setViewMode: any,
}


export const FireDangerTab: React.FC<FireDangerProps> = ({ station, viewMode, setViewMode }) =>{
  const [fuelModel, setFuelModel] = useState("Y");
  const location = useLocation();
  const [startDate, setStartDate] = useState<Date | null>(
    moment().subtract(14, "days").toDate()
  );
  const [endDate, setEndDate] = useState<Date | null>(
    moment().add(7, "days").toDate()
  );
  const [errorStartDate, setErrorStartDate] = useState<string | null>(
    null
  );
  const [errorEndDate, setErrorEndDate] = useState<string | null>(null);

  useEffect(()=>{
    if(location?.state){
      const station:any = location.state
      if(station.defaultView){
        setViewMode('daily')
      }
    }
    if(location?.pathname?.includes('daily')){
      setViewMode('daily')
    }

  },[location?.state, location?.pathname, setViewMode]);
  
/*TO DO once integration happens, make call to populate filters */

  return (
    <Box>

      {/* Filters */}
      <Box className="filter" >
        {/* Radio Buttons */}
        <RadioGroup 
        sx={{ paddingLeft : "3%",}}
        row value={viewMode}
          onChange={(e) => setViewMode(e.target.value)}>
          <FormControlLabel value="daily" control={<Radio 
          sx={{
            marginRight: '5px',
            color: "#016601", 
            backgroundColor: "white",
            width: "20%", 
              height: "20%",
            "&.Mui-checked": {
              color: "#016601", 
              backgroundColor: "white",
            },            
          }}
          />} label="Daily" />
          <FormControlLabel value="hourly" control={<Radio 
          sx={{
            marginRight: '5px',
            color: "#016601", 
            backgroundColor: "white",
            width: "20%", 
              height: "20%",
            "&.Mui-checked": {
              color: "#016601", 
            },
          }}
          />} label="Hourly" />
        </RadioGroup>

        {/* Date Range */}
        <Box>
          <div>
            <span className="font-sans-md text-bold">Date Range</span>{" "}
            <div
              className={`date-range-picker-wrapper`}
              style={{ margin: "10px 0" }}
            >
              <DatePicker
                label="Start Date"
                value={startDate}
                onChange={(newValue) => {
                  if (newValue) {
                    setStartDate(newValue);
                    if (endDate && newValue > endDate) {
                      setErrorStartDate("Start Date cannot be after End Date");
                    } else {
                      setErrorStartDate(null);
                    }
                  } else {
                    setErrorStartDate("Start Date is required");
                  }
                }}
                slotProps={{
                  textField: {
                    error: !!errorStartDate,
                    helperText: errorStartDate,
                    id: "uploadStartDate",
                    sx: {
                      backgroundColor: "white", 
                      borderRadius:"8%"
                    },
                  },
                }}
              />
              <span style={{ margin: "0 10px" }}></span>
              <DatePicker
                label="End Date"
                value={endDate}
                onChange={(newValue) => {
                  if (newValue) {
                    setEndDate(newValue);
                    if (startDate && newValue < startDate) {
                      setErrorEndDate("End Date cannot be before Start Date");
                    } else {
                      setErrorEndDate(null);
                    }
                  } else {
                    setErrorEndDate("End Date is required");
                  }
                }}
                slotProps={{
                  textField: {
                    error: !!errorEndDate,
                    helperText: errorEndDate,
                    id: "uploadEndDate",
                    sx: {
                      backgroundColor: "white", 
                      borderRadius:"8%"
                    },
                  },
                }}
              />
            </div>
          </div>
        </Box>

        {/* Fuel Model */}
        <div>
          <label htmlFor='fuelmodelFireDanger' id="fuelmodelFireDanger" className="font-sans-md text-bold">Fuel Model</label>{" "}
          <div
            className={`date-range-picker-wrapper`}
            style={{ margin: "10px 0",backgroundColor: "white",borderRadius:"8%" }}
          >
            <Select
              id="fuelmodelFireDanger"
              labelId='fuelmodelFireDanger'
              name='fuelmodelFireDanger'
              value={fuelModel}
              onChange={(e) => setFuelModel(e.target.value)}
              sx={{ minWidth: 200 }}
            >
              <MenuItem value="V">V</MenuItem>
              <MenuItem value="W">W</MenuItem>
              <MenuItem value="X">X</MenuItem>
              <MenuItem value="Y">Y</MenuItem>
              <MenuItem value="Z">Z</MenuItem>
            </Select>
          </div>
        </div>
      </Box>

      {/* Table for Hourly */}
      {viewMode === "hourly" && (
        <NfdrHourly station={station} fuelModel={fuelModel} startDate={startDate} endDate={endDate}/>
      )}

      {/* Table for Daily */}
      {viewMode === "daily" && (
        <NfdrDaily station={station} fuelModel={fuelModel} startDate={startDate} endDate={endDate}/>
      )}
    </Box>
  );
}
